/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { NoveltyCalcKeyFigureYearSegmentDto } from './NoveltyCalcKeyFigureYearSegmentDto';
import {
    NoveltyCalcKeyFigureYearSegmentDtoFromJSON,
    NoveltyCalcKeyFigureYearSegmentDtoFromJSONTyped,
    NoveltyCalcKeyFigureYearSegmentDtoToJSON,
    NoveltyCalcKeyFigureYearSegmentDtoToJSONTyped,
} from './NoveltyCalcKeyFigureYearSegmentDto';

/**
 * 
 * @export
 * @interface NoveltyCalcKeyFigureStatusRowDto
 */
export interface NoveltyCalcKeyFigureStatusRowDto {
    /**
     * 
     * @type {NoveltyCalcKeyFigureYearSegmentDto}
     * @memberof NoveltyCalcKeyFigureStatusRowDto
     */
    novelties: NoveltyCalcKeyFigureYearSegmentDto;
    /**
     * 
     * @type {NoveltyCalcKeyFigureYearSegmentDto}
     * @memberof NoveltyCalcKeyFigureStatusRowDto
     */
    novelties1Hy: NoveltyCalcKeyFigureYearSegmentDto;
    /**
     * 
     * @type {NoveltyCalcKeyFigureYearSegmentDto}
     * @memberof NoveltyCalcKeyFigureStatusRowDto
     */
    novelties2Hy: NoveltyCalcKeyFigureYearSegmentDto;
    /**
     * 
     * @type {NoveltyCalcKeyFigureYearSegmentDto}
     * @memberof NoveltyCalcKeyFigureStatusRowDto
     */
    carryOvers: NoveltyCalcKeyFigureYearSegmentDto;
    /**
     * 
     * @type {NoveltyCalcKeyFigureYearSegmentDto}
     * @memberof NoveltyCalcKeyFigureStatusRowDto
     */
    total: NoveltyCalcKeyFigureYearSegmentDto;
}

/**
 * Check if a given object implements the NoveltyCalcKeyFigureStatusRowDto interface.
 */
export function instanceOfNoveltyCalcKeyFigureStatusRowDto(value: object): value is NoveltyCalcKeyFigureStatusRowDto {
    if (!('novelties' in value) || value['novelties'] === undefined) return false;
    if (!('novelties1Hy' in value) || value['novelties1Hy'] === undefined) return false;
    if (!('novelties2Hy' in value) || value['novelties2Hy'] === undefined) return false;
    if (!('carryOvers' in value) || value['carryOvers'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function NoveltyCalcKeyFigureStatusRowDtoFromJSON(json: any): NoveltyCalcKeyFigureStatusRowDto {
    return NoveltyCalcKeyFigureStatusRowDtoFromJSONTyped(json, false);
}

export function NoveltyCalcKeyFigureStatusRowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoveltyCalcKeyFigureStatusRowDto {
    if (json == null) {
        return json;
    }
    return {
        
        'novelties': NoveltyCalcKeyFigureYearSegmentDtoFromJSON(json['novelties']),
        'novelties1Hy': NoveltyCalcKeyFigureYearSegmentDtoFromJSON(json['novelties1Hy']),
        'novelties2Hy': NoveltyCalcKeyFigureYearSegmentDtoFromJSON(json['novelties2Hy']),
        'carryOvers': NoveltyCalcKeyFigureYearSegmentDtoFromJSON(json['carryOvers']),
        'total': NoveltyCalcKeyFigureYearSegmentDtoFromJSON(json['total']),
    };
}

export function NoveltyCalcKeyFigureStatusRowDtoToJSON(json: any): NoveltyCalcKeyFigureStatusRowDto {
    return NoveltyCalcKeyFigureStatusRowDtoToJSONTyped(json, false);
}

export function NoveltyCalcKeyFigureStatusRowDtoToJSONTyped(value?: NoveltyCalcKeyFigureStatusRowDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'novelties': NoveltyCalcKeyFigureYearSegmentDtoToJSON(value['novelties']),
        'novelties1Hy': NoveltyCalcKeyFigureYearSegmentDtoToJSON(value['novelties1Hy']),
        'novelties2Hy': NoveltyCalcKeyFigureYearSegmentDtoToJSON(value['novelties2Hy']),
        'carryOvers': NoveltyCalcKeyFigureYearSegmentDtoToJSON(value['carryOvers']),
        'total': NoveltyCalcKeyFigureYearSegmentDtoToJSON(value['total']),
    };
}

